import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem("velta_user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("velta_token");
    if (!token) return;
    setLoading(true);
    api.get("/auth/me")
      .then((r) => {
        setUser(r.data);
        localStorage.setItem("velta_user", JSON.stringify(r.data));
      })
      .catch(() => {
        const tok = localStorage.getItem("velta_support_admin_token");
        const raw = localStorage.getItem("velta_support_admin_user");
        if (tok && raw) {
          localStorage.setItem("velta_token", tok);
          localStorage.setItem("velta_user", raw);
          localStorage.removeItem("velta_support_admin_token");
          localStorage.removeItem("velta_support_admin_user");
          try { setUser(JSON.parse(raw)); } catch { setUser(null); }
          window.location.href = "/admin/clienti";
          return;
        }
        localStorage.removeItem("velta_token");
        localStorage.removeItem("velta_user");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("velta_token", r.data.token);
    localStorage.setItem("velta_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  const activate = async (payload) => {
    const r = await api.post("/auth/activate", payload);
    localStorage.setItem("velta_token", r.data.token);
    localStorage.setItem("velta_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("velta_token");
    localStorage.removeItem("velta_user");
    localStorage.removeItem("velta_support_admin_token");
    localStorage.removeItem("velta_support_admin_user");
    setUser(null);
    window.location.href = "/";
  };

  const setSession = (token, newUser) => {
    localStorage.setItem("velta_token", token);
    localStorage.setItem("velta_user", JSON.stringify(newUser));
    setUser(newUser);
  };

  const beginImpersonation = (token, newUser) => {
    if (!localStorage.getItem("velta_support_admin_token")) {
      localStorage.setItem("velta_support_admin_token", localStorage.getItem("velta_token") || "");
      localStorage.setItem("velta_support_admin_user", localStorage.getItem("velta_user") || "");
    }
    setSession(token, newUser);
  };

  const exitImpersonation = () => {
    const tok = localStorage.getItem("velta_support_admin_token");
    const raw = localStorage.getItem("velta_support_admin_user");
    localStorage.removeItem("velta_support_admin_token");
    localStorage.removeItem("velta_support_admin_user");
    if (tok && raw) {
      try {
        setSession(tok, JSON.parse(raw));
        window.location.href = "/admin/clienti";
        return;
      } catch { /* fall through */ }
    }
    logout();
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, activate, logout, setUser, setSession, beginImpersonation, exitImpersonation }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
